/**
 * @module FE-CU05_パスワード初期化画面_秘密の質問
 */
import Header from '../../components/header/Header.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import PCFooter from '@/components/footer/PCFooter.vue';

const PAGE_ID = 'FE-CU05';

export default {
  name: 'PasswordInitSecretQuestion',
  components: {
    Header,
    PcPageTitle,
    BreadCrumbList,
    PCFooter,
  },
  data(vm) {
    return {
      dialog: false,
      isValid: false,
      mistakeDialog: false,
      accountLockedDialog: false,
      title: vm.$vuetify.lang.t('$vuetify.FECU05パスワード初期化画面秘密の質問.秘密の質問'),
      hintText: vm.$vuetify.lang.t(
        '$vuetify.メッセージ一覧.FECU05パスワード初期化画面秘密の質問.C0001'
      ),
      secretQuestion: '',
      answer: '',
      answerError: '',
      errorCount: 0,
      errorCounter: {
        errorCounter: function () {
          this.errorCount++;
        },
      },
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    confirmAnswer() {
      // required
      if (this.answer === '') {
        this.isValid = false;
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU05パスワード初期化画面秘密の質問.E0001'
          ),
        ];
      }
      // hiragana
      if (/^[ぁ-ん]+$/.test(this.answer)) {
        this.isValid = true;
        return [true];
      } else {
        this.isValid = false;
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU05パスワード初期化画面秘密の質問.E0005'
          ),
        ];
      }
    },
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU05パスワード初期化画面秘密の質問.秘密の質問'),
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU05パスワード初期化画面秘密の質問.C0001'
        ),
      };
    },
  },
  watch: {
    // 次へボタン活性制御
    answer() {
      this.isValid = this.$refs.form.validate();
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 次へボタン押下時処理
     */
    submit() {
      if (this.$refs.form.validate()) {
        // success
        this.isValid = true;
        this.APP_CU0502();
      }
    },
    /**
     * APP_CU0501 秘密の質問取得
     * @param {string} param エンドポイント
     * @param {object} queries リクエスト
     * @param {string} method HTTPメソッド
     * @returns {object} レスポンス
     */
    APP_CU0501: async function (param, queries, method) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     oneTimeUrlStatus: 0,
            //     secretQuestion: "母親の旧姓は",
            //   },
            // };

            if (apiData.contentsInfo.oneTimeUrlStatus == 0) {
              // 取得したデータを画面に出力する。
              this.secretQuestion = apiData.contentsInfo.secretQuestion;
            } else {
              // Thanks画面に遷移し失効したワンタイムURLのメッセージを表示する。
              this.$store.commit('setThanksType', {
                fromPageInfo: { page: 0 },
                displayType: 5,
              });
              this.$router.replace({ path: '/thanks' });
            }
          },
          (error) => {
            // 異常系の処理
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * APP_CU0502 秘密の質問確認
     */
    APP_CU0502: async function () {
      this.$_setLoading(true);

      // let param = "post";
      let param = '/api/passwordInitSecretQuestion/verifyAnswer';
      // let param = "status/400";

      let queries = {
        oneTimeUrlId: this.$route.params.oneTimeUrlID,
        secretAnswer: this.answer,
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     oneTimeUrlStatus: 0,
            //     isLockedAccount: false,
            //     isVerifiedAnswer: true,
            //     modified: "",
            //   },
            // };
            if (apiData.contentsInfo.oneTimeUrlStatus == 0) {
              if (
                apiData.contentsInfo.isLockedAccount == false &&
                apiData.contentsInfo.isVerifiedAnswer == true
              ) {
                this.$store.commit('setModifiedForNewPassword', {
                  modifiedForNewPassword: apiData.contentsInfo.modified,
                });
                // 回答をvuexに保存
                this.$store.commit('setAnswer', { answer: this.answer });
                // パスワード再登録画面へ遷移する。
                this.$router.replace({
                  path: '/passwordInitReregistration' + '/' + this.$route.params.oneTimeUrlID,
                });
              } else if (
                apiData.contentsInfo.isLockedAccount == false &&
                apiData.contentsInfo.isVerifiedAnswer == false
              ) {
                // エラーダイアログ(FE-CU5-E0003)を表示する。
                this.$errorDialog(
                  '$vuetify.メッセージ一覧.FECU05パスワード初期化画面秘密の質問.E0003'
                );
              } else {
                // エラーダイアログ(FE-CU5-E0004)を表示する。
                this.openAccountLockDialog();
              }
            } else {
              // Thanks画面に遷移し失効したワンタイムURLのメッセージを表示する。
              this.$store.commit('setThanksType', {
                fromPageInfo: { page: 0 },
                displayType: 5,
              });
              this.$router.replace({ path: '/thanks' });
            }
          },
          (error) => {
            if (error.response.status == '400') {
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU05パスワード初期化画面秘密の質問.E0003'
              );
            } else {
              // 異常系の処理
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * お知らせダイアログ
     */
    openAccountLockDialog: async function () {
      const result = await this.$informationDialog(
        '$vuetify.メッセージ一覧.FECU05パスワード初期化画面秘密の質問.E0004'
      );

      if (result) {
        // thanks画面に遷移
        this.$store.commit('setThanksType', {
          fromPageInfo: { page: 0 },
          displayType: 4,
        });
        this.$router.replace({ path: '/thanks' });
      }
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });

    // 検証の際には以下URLで遷移可能
    // ~~/passwordInitSecretQuestion/passwordInit/1 メインユーザーの本登録

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    this.$_pvCount(PAGE_ID);

    let param = '/api/passwordInitSecretQuestion/init'; // 本番用
    // let param = "post"; // 検証用

    let queries = {
      oneTimeUrlId: this.$route.params.oneTimeUrlID, // oneTimeUrlIDを取得
    };

    let method = 'post';
    await this.APP_CU0501(param, queries, method);
    //初期通信完了後に画面を表示
    this.isShowPage = true;
  },
};
